import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {AuthContextProvider} from './context/AuthContext'
import { ClientsContextProvider } from './context/ClientsContext';
import {QuotesContextProvider} from './context/QuotesContext'
import { InvoicesContextProvider } from './context/InvoiceContext';
import {disableReactDevTools} from '@fvilers/disable-react-devtools';
if (process.env.NODE_ENV === 'production') disableReactDevTools()

// We are providing the AuthContext to entire application below.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthContextProvider>
    <ClientsContextProvider>
      <QuotesContextProvider>
      <InvoicesContextProvider>

        
    <App />
    </InvoicesContextProvider>
    </QuotesContextProvider>
    </ClientsContextProvider>
    </AuthContextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

